module.exports = __webpack_public_path__ + "img/colleagues-giving-fist-bump2.f2c2312f.png";